import { JobShiftCell } from './job-shift-cell.model';

export class InpatientCell extends JobShiftCell {
    census: number;
    isWeekday: boolean;
    isWeekend: boolean;
}